import { TimeSlot } from "@clipboard-health/contract-worker-app-bff";
import { CardActionArea } from "@mui/material";
import { InternalLink } from "@src/appV2/lib";
import { useGetQualificationDisplayLabels } from "@src/appV2/Qualifications/api/useGetQualificationDisplayLabels";
import { Card } from "@src/appV2/redesign/system/ui-components";
import { DEFAULT_TIMEZONE } from "@src/appV2/Shifts/Shift/constants";
import { shiftPeriodToTimeSlot } from "@src/appV2/Shifts/Shift/types";

import { getFormattedShiftPayBreakdown } from "../../Shift/getFormattedShiftPayBreakdown";
import { WorkerShiftCard } from "../../Shift/WorkerShift/Card";
import { BOOKING_REQUESTS_FULL_PATH } from "../path";
import {
  type BookingRequestIncludedOffer,
  type BookingRequestIncludedShift,
  type BookingRequestIncludedWorkplace,
} from "./types";

interface BookingRequestShiftCardProps {
  shift: BookingRequestIncludedShift;
  workplace: BookingRequestIncludedWorkplace;
  offer: BookingRequestIncludedOffer;
}

export function BookingRequestShiftCard(props: BookingRequestShiftCardProps) {
  const { shift, workplace, offer } = props;

  const payBreakdown = getFormattedShiftPayBreakdown(
    offer.attributes.pay.value,
    shift.attributes.time * offer.attributes.pay.value,
    shift.attributes.time * offer.attributes.pay.value
  );
  const href = `${BOOKING_REQUESTS_FULL_PATH}/shift/${shift.id}`;

  const { data: qualificationDisplayLabels } = useGetQualificationDisplayLabels([
    shift.attributes.qualification,
  ]);
  // eslint-disable-next-line prefer-destructuring
  const qualificationText = qualificationDisplayLabels[0];

  return (
    <Card variant="quaternary">
      <CardActionArea component={InternalLink} to={href}>
        <WorkerShiftCard
          isBookingRequest
          shiftId={shift.id}
          workplaceId={workplace.id}
          workplaceName={workplace.attributes.name}
          workplaceTimezone={workplace.attributes.tmz ?? DEFAULT_TIMEZONE}
          // Booking-request cards intentionally don't show break details — pass undefined
          // explicitly so the card renders without a break notice regardless of the
          // shift's break policy.
          // eslint-disable-next-line unicorn/no-useless-undefined
          workplaceRequiresLunchBreak={undefined}
          // eslint-disable-next-line unicorn/no-useless-undefined
          shiftBreakPolicy={undefined}
          shiftTimeSlot={shiftPeriodToTimeSlot[shift.attributes.name] ?? TimeSlot.AM}
          shiftStart={shift.attributes.start}
          shiftEnd={shift.attributes.end}
          shiftQualificationName={qualificationText}
          shiftHourlyPay={payBreakdown?.hourlyPay}
          shiftTotalPay={payBreakdown?.totalPay}
        />
      </CardActionArea>
    </Card>
  );
}
